export let UPLOAD_VIDEO_EVENTS;
(function (UPLOAD_VIDEO_EVENTS) {
  UPLOAD_VIDEO_EVENTS["START"] = "start";
  UPLOAD_VIDEO_EVENTS["UPLOAD_PROGRESS"] = "upload:progress";
  UPLOAD_VIDEO_EVENTS["UPLOAD_STATUS_CHANGE"] = "upload:status-change";
  UPLOAD_VIDEO_EVENTS["UPLOAD_SUCCESS"] = "upload:success";
  UPLOAD_VIDEO_EVENTS["TRANSCODING_QUEUED"] = "transcoding:queued";
  UPLOAD_VIDEO_EVENTS["TRANSCODING_START"] = "transcoding:start";
  UPLOAD_VIDEO_EVENTS["TRANSCODING_PREVIEW_READY"] = "transcoding:preview-ready";
  UPLOAD_VIDEO_EVENTS["SUCCESS"] = "success";
  UPLOAD_VIDEO_EVENTS["ERROR"] = "error";
  UPLOAD_VIDEO_EVENTS["CHANGE"] = "change";
})(UPLOAD_VIDEO_EVENTS || (UPLOAD_VIDEO_EVENTS = {}));
//# sourceMappingURL=upload-video-events.js.map